import {createAction} from 'redux-actions';
import {apiGet, apiPost} from '../api';

const actions = {
  send_data: createAction('CONVERSION_SEND_DATA'),
  conversion_succeeded: createAction('CONVERSION_SUCCEEDED'),
  conversion_failed: createAction('CONVERSION_FAILED'),
};

export default actions;

const sendData = (uuid, response) => {
  return {
    type: actions.send_data.toString(),
    uuid,
    payload: response,
  };
};
const failed = (uuid, response) => {
  return {
    type: actions.conversion_failed.toString(),
    uuid,
    payload: response,
  };
};
export const getConversion = uuid => {
  return apiGet('agent/api/conversion/get',
      {uuid},
      (res) => sendData(uuid, res),
      actions.conversion_succeeded,
      (res) => failed(uuid, res));
};

export const submitConversion = (uuid, data) => {
  return apiPost('agent/api/conversion/update',
      {conversion_uuid: uuid, ...data},
      (res) => sendData(uuid, res),
      actions.conversion_succeeded,
      (res) => failed(uuid, res));
};
